import { useEffect } from 'react';
import { useSanityQuery } from './use-sanity-query';
import { setImageOverrides, type ImageOverrideRecord } from '@/lib/image-overrides';

export const IMAGE_OVERRIDES_DOC_ID = 'imageOverrides';

export const IMAGE_OVERRIDES_QUERY = `*[_type == "imageOverrides"][0]{
  overrides[]{
    originalPath,
    alt,
    hidden,
    image,
    "url": image.asset->url
  }
}`;

export interface ImageOverridesDoc {
  overrides?: Array<
    ImageOverrideRecord & { image?: { asset?: { _ref?: string } } | null }
  >;
}

export function useImageOverridesQuery() {
  return useSanityQuery<ImageOverridesDoc | null>(['imageOverrides'], IMAGE_OVERRIDES_QUERY);
}

/** Mounted once at app root: hydrates the module-level override map. */
export function useImageOverrides() {
  const { data } = useImageOverridesQuery();

  useEffect(() => {
    setImageOverrides(
      (data?.overrides || []).map((o) => ({
        originalPath: o.originalPath,
        url: o.url ? `${o.url}?auto=format&q=80` : null,
        alt: o.alt,
        hidden: o.hidden,
      }))
    );
  }, [data]);
}
